import React from 'react';
import { CheckSquare, Frame } from 'lucide-react';

const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-indigo-500" />
        Дополнительные элементы
      </h3>
      
      <div className="grid grid-cols-1 gap-4">
        {/* Плинтус */}
        <div>
          <label className="inline-flex items-center mb-2">
            <input
              type="checkbox"
              name="includeBaseboard"
              checked={formData.includeBaseboard}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать покраску плинтусов
            </span>
          </label>
          
          {formData.includeBaseboard && (
            <div className="relative mt-2">
              <label htmlFor="baseboardLength" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Длина плинтусов (м)
              </label>
              <div className="relative">
                <input
                  type="text"
                  id="baseboardLength"
                  name="baseboardLength"
                  value={formData.baseboardLength}
                  onChange={handleInputChange}
                  className={`form-input w-full ${errors.baseboardLength ? 'input-error' : ''}`}
                  placeholder="Длина плинтусов"
                />
                <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 dark:text-gray-400 pointer-events-none">
                  м
                </span>
              </div>
              {errors.baseboardLength && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.baseboardLength}
                </p>
              )}
            </div>
          )}
        </div>

        {/* Лепнина/Молдинги */}
        <div>
          <label className="inline-flex items-center mb-2">
            <input
              type="checkbox"
              name="includeStucco"
              checked={formData.includeStucco}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать покраску лепнины/молдингов
            </span>
          </label>
          
          {formData.includeStucco && (
            <div className="relative mt-2">
              <label htmlFor="stuccoLength" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Длина лепнины/молдингов (м)
              </label>
              <div className="relative">
                <input
                  type="text"
                  id="stuccoLength"
                  name="stuccoLength"
                  value={formData.stuccoLength}
                  onChange={handleInputChange}
                  className={`form-input w-full ${errors.stuccoLength ? 'input-error' : ''}`}
                  placeholder="Длина лепнины"
                />
                <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 dark:text-gray-400 pointer-events-none">
                  м
                </span>
              </div>
              {errors.stuccoLength && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.stuccoLength}
                </p>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="mt-4 bg-gray-100 dark:bg-gray-700/30 p-3 rounded-lg border border-gray-200 dark:border-gray-700">
        <div className="flex items-start">
          <Frame className="w-5 h-5 text-indigo-600 dark:text-indigo-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              О дополнительных элементах
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              Дополнительные элементы интерьера, такие как плинтусы и лепнина, требуют отдельного расчета краски и часто окрашиваются в другой цвет. Для расчета мы используем стандартный расход для погонного метра таких элементов.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;